import React, { useEffect } from "react";
import homepageimg from "../assets/heroLlb.png";
import avatarImg from "../assets/demo1.jpg";
import lawyer2 from "../assets/demo2.jpg";
import lawyer3 from "../assets/demo3.jpg";
import lawyer4 from "../assets/demo4.jpg";
import { Link, useLocation } from "react-router-dom";
import aboutImg from "../assets/aboutImg.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logo from "../assets/logo.png";
import terms from "../assets/pdf/TERMS.pdf";
import privacy from "../assets/pdf/PRIVACY.pdf";

export default function Home() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace('#', '');
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);

  const testimonials = [
    {
      name: 'Ashish Linpane',
      role: 'District Court Lawyer',
      avatar: avatarImg,
      text: 'I use the translation and summarization tools daily to prepare for hearings. The AI reliably captures legal nuance and saves me hours each week without compromising accuracy.'
    },
    {
      name: 'Ashwin Kapadnis',
      role: 'High Court Lawyer',
      avatar: lawyer2,
      text: 'Advocate Diary keeps my case notes, filings, and timelines perfectly organized. I especially like the reminders and quick search—client meetings are smoother and more productive.'
    },
    {
      name: 'Shane Ilahi Turky',
      role: 'Supreme Court Lawyer',
      avatar: lawyer3,
      text: 'Judge and Lawyer view is a game changer. Sharing structured briefs and exhibits in seconds reduces back‑and‑forth and helps everyone focus on the merits of the matter.'
    },
    {
      name: 'Karim Pathan',
      role: 'Supreme Court Lawyer',
      avatar: lawyer4,
      text: 'The platform\'s privacy controls and audit trails are excellent. I can collaborate with my team securely while maintaining a complete record of every change and access.'
    },
    {
      name: 'Riya Deshmukh',
      role: 'Corporate Counsel',
      avatar: avatarImg,
      text: 'Contract review is much faster now. Clause extraction highlights risky terms instantly, and the plain‑language summaries help clients understand implications before they sign.'
    }
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    customPaging: () => (
      <div className="w-3 h-3 mx-2 mt-6 bg-white rounded-full"></div>
    ),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ]
  };

  return (
    <div className="relative overflow-hidden">
      {/* Global silver background fixed across the whole page */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(24,24,27,0.35)_0%,rgba(244,244,245,0.9)_42%,rgba(255,255,255,1)_50%,rgba(244,244,245,0.9)_58%,rgba(24,24,27,0.35)_100%)]"></div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-zinc-700/35 via-zinc-600/20 to-transparent"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-1/3 bg-gradient-to-l from-zinc-700/35 via-zinc-600/20 to-transparent"></div>
        <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-zinc-500/15 to-transparent"></div>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-52 bg-gradient-to-t from-zinc-500/20 to-transparent"></div>
        <div className="pointer-events-none absolute -left-24 -top-24 h-96 w-96 rounded-full bg-white/60 blur-2xl"></div>
        <div className="pointer-events-none absolute right-0 top-0 h-[560px] w-[560px] rounded-full bg-white/50 blur-2xl translate-x-1/3 -translate-y-1/3"></div>
      </div>

      {/* HERO */}
      <div className="w-full min-h-screen px-4 lg:px-8 pt-12 md:pt-12 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid h-full grid-cols-1 lg:grid-cols-2 gap-10 items-center min-h-[calc(100vh-3rem)]">
            <div className="w-full max-w-none pr-4 lg:pr-8 -translate-y-2">
              <h1 className="font-montserrat text-[40px] sm:text-[48px] lg:text-[56px] xl:text-[64px] 2xl:text-[72px] font-semibold tracking-tight leading-[1] text-transparent bg-clip-text bg-[linear-gradient(90deg,#1f2937_0%,#4b5563_45%,#9ca3af_100%)]">
                <span className="block">SOLVING LEGAL</span>
                <span className="block">MATTERS WITH</span>
                <span className="block">CONFIDENCE</span>
              </h1>
              <p className="font-montserrat mt-6 text-lg text-gray-600 max-w-xl font-light">
                A dedicated legal team committed to protecting your rights and
                securing your future.
              </p>
              <div className="mt-8 flex items-center gap-4">
                <Link to="/contact">
                  <button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-6 rounded-xl shadow-md transition flex items-center gap-2">
                    <span>Contact Us</span>
                    <span aria-hidden>→</span>
                  </button>
                </Link>
                <Link to="/about">
                  <button className="bg-white hover:bg-gray-50 text-gray-900 font-semibold py-3 px-6 rounded-xl shadow-md border border-gray-200 transition">
                    Learn More
                  </button>
                </Link>
              </div>

              <div className="mt-10">
                <div className="relative rounded-3xl p-4 pr-6 flex items-center gap-6">
                  <div className="inline-block relative">
                    <img src={avatarImg} alt="Profile" className="h-24 w-24 rounded-2xl object-cover border border-white/60" />
                    <div className="absolute -top-2 -right-4 h-9 w-9 rounded-full bg-white text-gray-900 grid place-items-center shadow-md border border-white/70">↗</div>
                  </div>
                  <div className="flex-1">
                    <div className="text-sm uppercase tracking-wider text-gray-600">PROTECTING EVERY</div>
                    <div className="text-2xl font-semibold text-gray-700 -mt-0.5">DEAL YOU MAKE</div>
                    <a href="#get-started" className="mt-3 inline-block text-sm tracking-wide text-gray-700 underline decoration-2 underline-offset-8">GET STARTED</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative h-full flex items-end justify-center">
              <div
                className="relative w-full max-w-4xl md:max-w-5xl lg:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl mx-auto lg:-translate-x-24 xl:-translate-x-32 2xl:-translate-x-40 overflow-hidden rounded-b-3xl bottom-0"
                style={{ WebkitMaskImage: "linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 62%, rgba(0,0,0,0.65) 80%, rgba(0,0,0,0.25) 92%, rgba(0,0,0,0) 100%)", maskImage: "linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 62%, rgba(0,0,0,0.65) 80%, rgba(0,0,0,0.25) 92%, rgba(0,0,0,0) 100%)" }}
              >
                <img src={homepageimg} alt="Justice statue" className="w-full drop-shadow-2xl select-none" />
              </div>

              <div className="absolute top-8 right-2 sm:top-10 sm:right-6 bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl shadow-xl p-4 text-left">
                <div className="text-4xl font-semibold text-gray-900">28K</div>
                <div className="mt-2 flex items-center justify-start">
                  <div className="relative flex items-center">
                    <img src={avatarImg} alt="Member 1" className="h-8 w-8 rounded-full object-cover border-2 border-white/80" />
                    <img src={avatarImg} alt="Member 2" className="h-8 w-8 rounded-full object-cover border-2 border-white/80 -ml-2" />
                    <img src={avatarImg} alt="Member 3" className="h-8 w-8 rounded-full object-cover border-2 border-white/80 -ml-2" />
                    <div className="h-7 w-7 -ml-2 rounded-full bg-white text-gray-900 grid place-items-center shadow border border-white/70">↗</div>
                  </div>
                </div>
                <p className="mt-2 text-xs text-gray-600 max-w-[180px] text-left">Partner with us as we protect your rights</p>
              </div>

              <div className="absolute bottom-16 right-2 sm:right-6">
                <div className="relative w-[320px] sm:w-[360px] rounded-3xl bg-gradient-to-b from-white/70 via-white/40 to-white/30 backdrop-blur-xl border border-white/30 shadow-[0_10px_25px_rgba(0,0,0,0.08)] p-4">
                  <div className="flex items-center justify-between">
                    <div className="text-[13px] text-gray-800 font-medium">Case Closure Statistics</div>
                    <button className="text-[11px] flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-white/70 text-gray-700 border border-white/60 shadow-sm">Yearly
                      <span className="text-gray-600">▾</span>
                    </button>
                  </div>
                  <div className="mt-3 flex">
                    <div className="mr-3 grid content-between text-[10px] text-gray-500 h-28">
                      <span>40</span>
                      <span>30</span>
                      <span>20</span>
                      <span>10</span>
                    </div>
                    <div className="relative flex-1 px-4 pb-1">
                      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/10 via-gray-700/5 to-transparent pointer-events-none"></div>
                      <div className="flex items-end justify-between h-28 gap-2">
                        {[22,34,49,60,46,40,60].map((h, i) => (
                          <div
                            key={i}
                            className="w-6 bg-gradient-to-t from-gray-900/25 to-gray-900/70 border border-white/40"
                            style={{ height: `${h}%` }}
                          ></div>
                        ))}
                      </div>
                      <div className="mt-2 text-[10px] text-gray-600 flex justify-between px-1">
                        {['Jan','Feb','Mar','Apr','May','Jun','Jul'].map((m) => (<span key={m}>{m}</span>))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pointer-events-none absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-4">
          {['in','f','x'].map((label) => (
            <div key={label} className="pointer-events-auto h-10 w-10 rounded-xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-md grid place-items-center text-gray-800 font-semibold">{label}</div>
          ))}
        </div>
      </div>

      {/* ABOUT SECTION */}
      <div id="about" className="relative z-10 py-16 md:py-20 scroll-mt-24">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="lg:w-1/2 lg:pr-12">
                <div className="rounded-3xl bg-white/50 backdrop-blur-xl border border-white/30 shadow-[0_10px_25px_rgba(0,0,0,0.08)] p-6 md:p-8">
                  <h2 className="font-montserrat text-[28px] sm:text-[32px] lg:text-[36px] font-semibold tracking-tight leading-[1.05] text-transparent bg-clip-text bg-[linear-gradient(90deg,#1f2937_0%,#4b5563_45%,#9ca3af_100%)] mb-4">
                    Get all your questions and queries of your documents solved in seconds.
                  </h2>
                  <p className="text-base sm:text-lg text-gray-700/80">
                    Translate, summarize, and simplify legal documents easily. Upload your document to receive accurate translations and simplified summaries in your regional language.
                  </p>
                </div>
              </div>
              <div className="lg:w-1/2 relative">
                <div className="relative w-full max-w-xl ml-auto">
                  <div className="relative rounded-3xl bg-gradient-to-b from-white/70 via-white/40 to-white/30 backdrop-blur-xl border border-white/30 shadow-[0_10px_25px_rgba(0,0,0,0.08)] p-3 sm:p-4">
                    <div className="relative">
                      <img
                        src={aboutImg}
                        alt="Document analysis illustration"
                        className="w-full h-auto max-h-[70vh] md:max-h-[80vh] object-contain rounded-2xl border border-white/60 shadow-xl"
                        style={{ WebkitMaskImage: "linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 80%, rgba(0,0,0,0) 100%)", maskImage: "linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 80%, rgba(0,0,0,0) 100%)" }}
                      />
                    </div>
                    <div className="absolute top-4 right-6 bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl shadow-xl px-5 py-2.5 text-[14px] sm:text-[15px] text-gray-800">
                      Secure & Private ↗
                    </div>
                    {/* Floating feature tags around the image */}
                    <div className="absolute top-4 left-6 bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl shadow-xl px-5 py-2.5 text-[14px] sm:text-[15px] text-gray-800">
                      AI Translation
                    </div>
                    <div className="absolute bottom-64 -translate-y-1/2 left-4 bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl shadow-xl px-5 py-2.5 text-[14px] sm:text-[15px] text-gray-800 hidden sm:block">
                      Smart Summaries
                    </div>
                    <div className="absolute bottom-6 left-8 bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl shadow-xl px-5 py-2.5 text-[14px] sm:text-[15px] text-gray-800 hidden sm:block">
                      24/7 Availability
                    </div>
                    <div className="absolute bottom-6 right-8 bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl shadow-xl px-5 py-2.5 text-[14px] sm:text-[15px] text-gray-800">
                      Legal Simplification
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SERVICES SECTION */}
      <div id="services" className="relative z-10 w-full px-4 sm:px-6 lg:px-8 py-16 md:py-20 scroll-mt-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <p className="text-2xl sm:text-3xl text-gray-800">Services</p>
            <h2 className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-[linear-gradient(90deg,#111827_0%,#1f2937_45%,#374151_70%,#4b5563_100%)]">
              What We Offer
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {["AI Translation","Document Summaries","Advocate Diary"].map((title) => (
              <div key={title} className="rounded-3xl bg-gradient-to-b from-white/70 via-white/40 to-white/30 backdrop-blur-xl border border-white/40 shadow-[0_10px_25px_rgba(0,0,0,0.08)] p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{title}</h3>
                <p className="text-sm text-gray-700/90">High-quality, secure, and fast. Designed for legal workflows with privacy and auditability.</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* TESTIMONIALS SECTION */}
      <div id="testimonials" className="relative z-10 w-full px-4 sm:px-6 lg:px-8 py-12 md:py-16 scroll-mt-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <p className="text-2xl sm:text-3xl text-gray-800">Testimonials</p>
            <h2 className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-[linear-gradient(90deg,#111827_0%,#1f2937_45%,#374151_70%,#4b5563_100%)] mb-6">
              Check What Our Clients<br />Think About Us
            </h2>
          </div>
          <Slider {...sliderSettings} className="custom-slider">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="px-4">
                <div className="rounded-3xl bg-gradient-to-b from-white/70 via-white/40 to-white/30 backdrop-blur-xl border border-white/40 shadow-[0_10px_25px_rgba(0,0,0,0.08)] p-8 min-h-[18rem] flex flex-col">
                  <div className="text-4xl text-gray-800/70 mb-4">"</div>
                  <div className="flex items-center mb-3">
                    <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full mr-4 object-cover border border-white/70" />
                    <div>
                      <h3 className="font-semibold text-gray-800 leading-tight">{testimonial.name}</h3>
                      {testimonial.role && (
                        <div className="text-xs text-gray-600 mt-0.5">{testimonial.role}</div>
                      )}
                    </div>
                  </div>
                  <p className="text-gray-700/90 text-sm leading-6 flex-1">{testimonial.text}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* FOOTER SECTION */}
      <div className="relative z-10 py-8">
        <div className="w-full px-4 py-12 mt-20">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row justify-between items-center mb-12">
              <div className="md:w-1/2 mb-8 md:mb-0">
                <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-[linear-gradient(90deg,#1f2937_0%,#4b5563_45%,#9ca3af_100%)] mb-4">
                  Get Updates
                </h2>
                <p className="text-gray-700/80">
                  Sign up for our mailing list to receive news and updates. You can unsubscribe at any time.
                </p>
              </div>
              <div className="md:w-1/2">
                <div className="flex items-center rounded-full p-1 bg-gradient-to-b from-white/70 via-white/40 to-white/30 backdrop-blur-xl border border-white/40 shadow-[0_10px_25px_rgba(0,0,0,0.08)]">
                  <input
                    type="email"
                    placeholder="Enter Email"
                    className="w-full px-4 py-2 rounded-full focus:outline-none bg-transparent placeholder:text-gray-600/80 text-gray-800"
                  />
                  <button className="text-white px-6 py-2 rounded-full bg-gradient-to-r from-gray-700 to-gray-500 shadow-md border border-white/40">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full px-4">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col md:flex-row justify-between items-center">
                <div className="mb-4 md:mb-0">
                  <img src={logo} alt="Company Logo" className="w-52 drop-shadow" />
                </div>
                <div className="flex space-x-4">
                  <button type="button" aria-label="Open Instagram" className="text-gray-700 hover:text-gray-900">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                    </svg>
                  </button>
                  <button type="button" aria-label="Open Twitter" className="text-gray-700 hover:text-gray-900">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                  </button>
                  <button type="button" aria-label="Open GitHub" className="text-gray-700 hover:text-gray-900">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                    </svg>
                  </button>
                  <button type="button" aria-label="Open LinkedIn" className="text-gray-700 hover:text-gray-900">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>
              <div className="mt-8 text-center md:text-right">
                <a target="_blank" rel="noreferrer" href={terms} className="text-gray-700 hover:text-gray-900 mx-2">Terms of services</a>
                <a target="_blank" rel="noreferrer" href={privacy} className="text-gray-700 hover:text-gray-900 mx-2">Privacy Policies</a>
                <button type="button" className="text-gray-700 hover:text-gray-900 mx-2">Cookie privacy</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}